var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"remove-btn-style"},[_c('a',{staticClass:"mr-1",attrs:{"title":_vm.$t('invoice.cancel')},on:{"click":_vm.toggleModal}},[_c('i',{staticClass:"fa fa-ban color-is-danger color-is-warning",attrs:{"aria-hidden":"true"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }